export class FiatLimit {
	private limit: string = "";
	private id: string = "";

	public getFiatId(): string {
		return this.id;
	}

	public getLimit(): number {
		return this.getAmount();
	}

	public getAmount(): number {
		return +this.limit;
	}
}
